import { AdminHomePage, AdminSpaceDetailPage, LoginPage } from "./admin/pages/AdminPages";
import { isAdminMockMode } from "./admin/mock/mockApi";
import {
  getAdminSpaceId,
  isAdminSpacePath,
  normalizePath,
  type NormalizedRoutePath
} from "./shared/routes";
import { SiteLayout } from "./site/components/SiteLayout";
import {
  ContactPage,
  DownloadPage,
  HomePage,
  HowItWorksPage,
  NotFoundPage,
  OpenSourceNoticesPage,
  PricingPage,
  PrivacyPage,
  PrivacySecurityPage,
  ProductPage,
  SafetyPage,
  SupportPage,
  TermsPage,
  WhitepaperPage
} from "./site/pages/SitePages";

export function App() {
  const activePath = normalizePath(window.location.pathname);

  return (
    <SiteLayout activePath={activePath}>
      {renderRoute(activePath)}
    </SiteLayout>
  );
}

function renderRoute(path: NormalizedRoutePath) {
  const adminMockMode = isAdminMockMode();

  if (isAdminSpacePath(path)) {
    if (!adminMockMode) {
      return <LoginPage />;
    }

    return <AdminSpaceDetailPage spaceId={getAdminSpaceId(path)} />;
  }

  switch (path) {
    case "/":
      return <HomePage />;
    case "/product":
      return <ProductPage />;
    case "/pricing":
      return <PricingPage />;
    case "/download":
      return <DownloadPage />;
    case "/how-it-works":
      return <HowItWorksPage />;
    case "/privacy-security":
      return <PrivacySecurityPage />;
    case "/whitepaper":
      return <WhitepaperPage />;
    case "/support":
      return <SupportPage />;
    case "/safety":
    case "/support/safety":
      return <SafetyPage />;
    case "/login":
      return <LoginPage />;
    case "/admin":
      if (!adminMockMode) {
        return <LoginPage />;
      }

      return <AdminHomePage />;
    case "/terms":
      return <TermsPage />;
    case "/privacy":
      return <PrivacyPage />;
    case "/open-source":
    case "/open-source-notices":
      return <OpenSourceNoticesPage />;
    case "/contact":
      return <ContactPage />;
    case "/not-found":
      return <NotFoundPage />;
  }
}
